export default __webpack_public_path__ + "static/media/fileword.3a7b7059.svg";